import { combineReducers } from 'redux';
import popular from './popularReducers';


export default combineReducers({
    popular,
})